import { NgModule, Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { CHABreadcrumbsComponent } from './chabreadcrumbs.component';

@NgModule({
  imports: [
    CommonModule
    , RouterModule
  ]
  , declarations: [
    CHABreadcrumbsComponent
  ]
  , exports: [
    CHABreadcrumbsComponent
  ]
})
export class CHABreadcrumbsModule { }
